import $ from "jquery";

window.bankDetailsModal = [];

$(() => {
  $(document).on("notify-form-reset", () => {
    const form = $("form#bank-details");
    if (form) {
      (form[0] as HTMLFormElement).reset();
    }
  });

  $(document).on("notify-modal-close", () => {
    for (const disclosure of window.bankDetailsModal) {
      disclosure.onClose();
    }
  });
});
